import { createSlice } from '@reduxjs/toolkit'
import { gameClose, userLogin } from 'redux-store/thunk/auth.thunk'
import { fetchUserInformation } from 'redux-store/thunk/user.thunk'
import { getPayloadFromToken } from 'utils/common-functions/index'
import { CURRENCY_SYMBOL } from 'utils/constants/index'


const getCurrencySymbol = (currencyCode) => {
  return CURRENCY_SYMBOL[currencyCode?.toUpperCase()] || currencyCode || '$'
}

const defaultAuthState = {
  creditWalletWaitQueue: [],
  userInfo: null,
  userDetails: null,
  currencyId: null,
  currencyCode: null,
  currencySymbol: null,
  isLoggedIn: false,
  showName: true,
  userInfoLoading: false,
  freeRound: null
}

const authSlice = createSlice({
  name: 'authSlice',
  initialState: defaultAuthState,
  reducers: {
    appendCreditWalletWaitQueue: (state, action) => {
      const currentQueue = state.creditWalletWaitQueue || []
      return {
        ...state,
        creditWalletWaitQueue: action.payload ? [...currentQueue, action.payload] : currentQueue
      }
    },
    updateCreditWalletWaitQueue: (state, action) => {
      const currentQueue = state.creditWalletWaitQueue || []
      if (currentQueue.length === 0) {
        return state
      }
      const _userInfoWallet = currentQueue[currentQueue.length - 1] ?? state.userInfo?.wallet
      const _creditWalletWaitQueue = currentQueue.slice(0, currentQueue.length - 1)
      return {
        ...state,
        creditWalletWaitQueue: _creditWalletWaitQueue,
        userInfo: state.userInfo ? {
          ...state.userInfo,
          wallet: _userInfoWallet
        } : state.userInfo
      }
    },
    updateUserWallet: (state, action) => ({
      ...state,
      userInfo: state.userInfo ? {
        ...state.userInfo,
        wallet: action.payload
      } : state.userInfo
    }),
    setShowName: (state, action) => {
      return {
        ...state,
        showName: !state.showName
      }
    },
    setUserInfo: (state, action) => ({
      ...state,
      userInfo: state.userInfo ? {
        ...state.userInfo,
        wallet: action.payload
      } : state.userInfo
    }),
    setFreeRound: (state, action) => ({
      ...state,
      freeRound: action.payload
    })
  },
  extraReducers: (builder) => {
    builder
      .addCase(userLogin.pending, (state, action) => {
        return {
          ...state,
          userInfoLoading: true
        }
      })
      .addCase(userLogin.fulfilled, (state, action) => {
        const { user, wallet, accessToken } = action.payload
        const payload = getPayloadFromToken(accessToken)
        const currencyId = payload?.currencyId
        const currencyCode = payload?.currencyCode
        const currencySymbol = getCurrencySymbol(currencyCode)
        return {
          ...state,
          currencyId,
          currencyCode,
          currencySymbol,
          userInfo: { user, wallet },
          isLoggedIn: true,
          userInfoLoading: false
        }
      })
      .addCase(userLogin.rejected, (state, action) => {
        return {
          ...state,
          userInfoLoading: false
        }
      })
      .addCase(fetchUserInformation.fulfilled, (state, action) => {
        return {
          ...state,
          userDetails: action.payload
        }
      })
      .addCase(gameClose.fulfilled, (state, action) => {
        return defaultAuthState
      })
  }
})

export const { setUserInfo, appendCreditWalletWaitQueue, updateCreditWalletWaitQueue, setShowName, setFreeRound, updateUserWallet } = authSlice.actions

export default authSlice.reducer
